export function isValidEmail(email: string): boolean {

    //This regex is quite complex but it is following the General Email Regex (RFC 5322 Official Standard)
    //We tried approaching this using Validators.email from angular forms but to no avail
    const pattern = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

    return pattern.test(email);
}